import { render, staticRenderFns } from "./PublicProfile.vue?vue&type=template&id=4b348390&scoped=true&"
import script from "./PublicProfile.vue?vue&type=script&lang=js&"
export * from "./PublicProfile.vue?vue&type=script&lang=js&"
import style0 from "./PublicProfile.vue?vue&type=style&index=0&id=4b348390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b348390",
  null
  
)

export default component.exports